function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7929 6.2013L20.2071 4.78708L16 0.579956L11.7929 4.78708L13.2071 6.2013L15 4.40838V13.59L13.2071 11.797L11.7929 13.2113L16 17.4183L20.2071 13.2113L18.7929 11.797L17 13.59V4.40838L18.7929 6.2013ZM-1.41859e-05 3.99996H11V1.99999H-6.10352e-05L-1.41859e-05 3.99996ZM8.99999 7.99999H-1.41859e-05V5.99997H8.99999V7.99999ZM-1.41859e-05 12H6.99997V9.99996H-6.10352e-05L-1.41859e-05 12ZM4.99995 16H-1.41859e-05V14H4.99995V16Z",
  fill: "#003E72"
});

function SvgReorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.8b367e44.svg";
export { ForwardRef as ReactComponent };